import { useState } from 'react';
import axios from 'axios';
import { endpoints, baseUrl } from '../api/api';
import { store } from '../store/store';
import { logout } from '../store/slices/authslice';

interface UseTermsConsentOptions {
  onAccept: () => void;
  onDecline: () => void;
}

export const useTermsConsent = ({ onAccept, onDecline }: UseTermsConsentOptions) => {
  const [showTerms, setShowTerms] = useState(false);

  const triggerTerms = () => setShowTerms(true);

  const handleAccept = async () => {
    const token = localStorage.getItem('accessToken');
    try {
      await axios.post(`${baseUrl}${endpoints.acceptTerms}`, {}, {
        headers: { Authorization: `Bearer ${token}` }
      });
    } catch (e) {}
    setShowTerms(false);
    onAccept();
  };

  const handleDecline = () => {
    const token = localStorage.getItem('accessToken');
    axios.post(`${baseUrl}${endpoints.declineTerms}`, {}, {
      headers: { Authorization: `Bearer ${token}` }
    }).catch(() => {}).finally(() => {
      localStorage.removeItem('accessToken');
      localStorage.removeItem('refreshToken');
      localStorage.removeItem('user');
      store.dispatch(logout()); // clear Redux auth state
      setShowTerms(false);
      onDecline();
    });
  };

  return { showTerms, triggerTerms, handleAccept, handleDecline };
};
